export interface User {
  uuid: string;
  fullName: string;
  email: string;
  role: Role;
  admin?: boolean;
  cabinetName?: string | null;
  cabinetPhone?: string | null;
  cabinetEmail?: string | null;
}

export interface UserDetailsResponse {
  uuid: string;
  fullName: string;
  email: string;
  role: Role;
  admin: boolean;
  cabinetName?: string | null;
  cabinetPhone?: string | null;
  cabinetEmail?: string | null;
}

export interface IAdminUserListItem {
  uuid: string;
  fullName: string;
  email: string;
  role: Role;
  admin: boolean;
  emailVerified: boolean;
  registeredAt: string;
}

export enum Role {
  EXECUTIVE = 'EXECUTIVE',
  ACCOUNTANT = 'ACCOUNTANT',
  ADMIN = 'ADMIN'
}

export interface IUserCompanyNotificationPreference {
  siret: string;
  companyName: string;
  enabled: boolean;
}

export interface IUserSettings {
  contactName: string | null;
  contactMail: string | null;
  cabinetName: string | null;
  cabinetPhone: string | null;
  cabinetEmail: string | null;
  legalAlertsEnabled: boolean;
  expiryAlertsEnabled: boolean;
  emailNotificationsEnabled: boolean;
  companyNotifications: IUserCompanyNotificationPreference[];
}

export interface IUserSettingsUpdate {
  contactName: string | null;
  contactMail: string | null;
  cabinetName: string | null;
  cabinetPhone: string | null;
  cabinetEmail: string | null;
  legalAlertsEnabled: boolean;
  expiryAlertsEnabled: boolean;
  emailNotificationsEnabled: boolean;
  companyNotifications: Array<{ siret: string; enabled: boolean }>;
}
